import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';

const AppShell = () => (
  <div className="App">
    <Header />
    <main className="pt-16 md:pt-20">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default AppShell;
